"use strict";
import { removeThaiBahtFromFiatCurrency } from "uniswap/src/state/uniswapMigrations";
export const migration25 = (state) => {
  if (!state) {
    return void 0;
  }
  return {
    ...removeThaiBahtFromFiatCurrency(state),
    _persist: { ...state._persist, version: 25 }
  };
};
